import React, { useState, useEffect } from "react";

import { Map, Marker, GoogleApiWrapper, InfoWindow } from "google-maps-react";

import * as firebase from "firebase/app";
import CircularProgress from "@material-ui/core/CircularProgress";

import MarkerIcon from "./statics/ic_pin.png";
import OfflineMarkerIcon from "./statics/offline_pin.png";
import AdminIcon from "./statics/admin_pin.png";

const database = firebase.database();

// tripid LiDp90IlcDkJIGYD6S7

export const MapCanvas = props => {
  const [data, setData] = useState([]);
  const [members, setMembers] = useState([]);
  const [defCenter, setDefCenter] = useState({});
  const [showingInfo, setShowInfo] = useState(false);
  const [activeMarker, setActiveMarker] = useState(null);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [circleRad, setCircleRad] = useState(1200);

  const onMarkerClick = (props, marker, e) => {
    setShowInfo(true);
    setActiveMarker(marker);
    setSelectedPlace(props);
  };

  const onMapClick = () => {
    if (showingInfo) {
      setShowInfo(false);
      setActiveMarker(null);
    }
  };

  useEffect(() => {
    firebase
      .database()
      .ref("/OseelaWebTripId")
      .once("value")
      .then(function(snapshot) {
        return snapshot.val();
      })
      .then(tripid => {
        database.ref("/Projects/" + tripid).on("value", snapshot => {
          setCircleRad(snapshot.val()._safezone);
          setMembers([
            snapshot.val()._proadmin,
            ...Object.values(snapshot.val()._members)
          ]);
        });
      });
  }, []);

  useEffect(() => {
    if (members.length) {
      database.ref("Userslatlan").on("value", snapshot => {
        let dataArray = [];
        const arrayLoop = new Promise((resolve, reject) => {
          members.forEach((member, index, array) => {
            if (index === 0) {
              dataArray.push(
                <Marker
                  key={member}
                  name={member}
                  position={{
                    lat: snapshot.val()[member]._lat,
                    lng: snapshot.val()[member]._lan
                  }}
                  onClick={onMarkerClick}
                  icon={{
                    url: AdminIcon,
                    scaledSize: new props.google.maps.Size(32, 32),
                    anchor: new props.google.maps.Point(16, 16)
                  }}
                />
              );
            } else {
              if (snapshot.val()[member]._isiton) {
                dataArray.push(
                  <Marker
                    key={member}
                    name={member}
                    position={{
                      lat: snapshot.val()[member]._lat,
                      lng: snapshot.val()[member]._lan
                    }}
                    onClick={onMarkerClick}
                    icon={{
                      url: MarkerIcon,
                      scaledSize: new props.google.maps.Size(32, 32),
                      anchor: new props.google.maps.Point(16, 16)
                    }}
                  />
                );
              } else {
                dataArray.push(
                  <Marker
                    key={member}
                    name={member}
                    position={{
                      lat: snapshot.val()[member]._lat,
                      lng: snapshot.val()[member]._lan
                    }}
                    onClick={onMarkerClick}
                    icon={{
                      url: OfflineMarkerIcon,
                      scaledSize: new props.google.maps.Size(32, 32),
                      anchor: new props.google.maps.Point(16, 16)
                    }}
                  />
                );
              }
            }

            if (index === array.length - 1) resolve();
          });
        });

        arrayLoop.then(() => {
          setDefCenter({
            lat: snapshot.val().rajihawa._lat,
            lng: snapshot.val().rajihawa._lan
          });
          setData(dataArray);
        });
      });
    }
  }, [members]);

  return data.length && members.length && defCenter.lat ? (
    <Map
      google={props.google}
      className={"map"}
      zoom={15}
      initialCenter={defCenter}
      onClick={onMapClick}
    >
      {/* <Circle
        radius={circleRad}
        center={data[0].props.position}
        strokeColor="transparent"
        strokeOpacity={0}
        strokeWeight={5}
        fillColor="#FF0000"
        fillOpacity={0.2}
      /> */}
      {data}
      <InfoWindow marker={activeMarker} visible={showingInfo}>
        <h1>{activeMarker ? activeMarker.name : null}</h1>
      </InfoWindow>
    </Map>
  ) : (
    <div className="loadingMap">
      <CircularProgress size={140} />
    </div>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyBEQFRk_IqVU2E9w79AwNFU7R7RbLVzWvk"
})(MapCanvas);

// apiKey: "AIzaSyBEQFRk_IqVU2E9w79AwNFU7R7RbLVzWvk";
